import React, { useState, useEffect } from "react";
import "../slots/slots.css";
import sportImage from "../../assets/svgs/football.svg";
import { Dropdown, Button, Form, Modal, Offcanvas, Row, Col, Card, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllSlots } from "../../redux/slotSlice";
import { fetchAllFacilities } from "../../redux/facilitySlice";
import Skeleton from "react-loading-skeleton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { createSlot } from "../../redux/slices/slotSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TrashIcon from "../../assets/svgs/trashicon-slots.svg";
import { deleteParentSlot } from "../../services/api";
import sportIcons from "../facilities/addfacility/sportsicon";
import CalenderIcon from "../../assets/svgs/calender.svg";
import LazyImage from "../LazyImage";
import "../LazyImage.css";
import "../bookings/bookings.css";
// Import icons for Review Modal styling
import idcard from "../../assets/svgs/id-icon.svg";
import sportsicon from "../../assets/sidepanel/sports.svg";
import priceicon from "../../assets/svgs/price-icon.svg";
import dateicon from "../../assets/svgs/date-icon.svg";
import timeicon from "../../assets/svgs/clock-min-icon.svg";
import facilityicon from "../../assets/svgs/flag-icon.svg";
import smallcal from "../../assets/svgs/smallest-date-icon.svg";
import facilityflag from "../../assets/sidepanel/flag.svg";
import pitch from "../../assets/sidepanel/pitch.svg";

// Add SkeletonSlotCard component at the top level
const SkeletonSlotCard = () => {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12">
      <div className="slot-card-wrapper">
        <div className="slot-header">
          <div className="sport-icon slots">
            <Skeleton circle width={60} height={60} />
          </div>
          <Skeleton width={120} height={20} />
        </div>

        <div className="slot-date">
          <Skeleton width={20} height={20} style={{ marginRight: '8px' }} />
          <Skeleton width={150} height={20} />
        </div>

        <div className="slot-title-skeleton">
          <Skeleton width={180} height={24} />
        </div>

        <div className="slot-days" style={{ marginTop: '15px' }}>
          {[1, 2, 3].map((_, idx) => (
            <Skeleton key={idx} width={60} height={24} style={{ marginRight: '8px', borderRadius: '12px' }} />
          ))}
        </div>

        <div className="slot-actions" style={{ marginTop: '20px' }}>
          <Skeleton width={120} height={36} style={{ marginRight: '10px', borderRadius: '18px' }} />
          <Skeleton width={100} height={36} style={{ borderRadius: '18px' }} />
        </div>
      </div>
    </div>
  );
};

const Slots = () => {
  // const [filterOpen, setFilterOpen] = useState(false);
  const [sportsFilterOpen, setSportsFilterOpen] = useState(false);
  const [facilitiesFilterOpen, setFacilitiesFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  // const [showReviewModal, setShowReviewModal] = useState(false);
  const [showReplicateModal, setShowReplicateModal] = useState(false);
  const [showReplicateReviewModal, setShowReplicateReviewModal] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [replicateData, setReplicateData] = useState({
    name: "",
    startDate: new Date(),
    endDate: new Date(),
  });
  // const [errorMessage, setErrorMessage] = useState("");
  // const [showErrorModal, setShowErrorModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedSports, setSelectedSports] = useState([]);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [availableSports, setAvailableSports] = useState([]);
  const itemsPerPage = 6;
  const dispatch = useDispatch();

  const slotViewData = useSelector((state) => state.slots?.data || []);
  const facilities = useSelector((state) => state.facilities?.facilities || []);
  const [isLoading, setIsLoading] = useState(true);
  const { loading: slotLoading, error: slotError, success: slotSuccess } = useSelector(state => state.slots);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [slotToDelete, setSlotToDelete] = useState(null);

  const [showReviewOffcanvas, setShowReviewOffcanvas] = useState(false);

  // Modify the useEffect to properly handle loading state
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(fetchAllSlots()),
          dispatch(fetchAllFacilities())
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load slots data");
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [dispatch]);

  // Extract unique sports from slots data
  useEffect(() => {
    if (slotViewData && slotViewData.length > 0) {
      const sports = new Set();
      slotViewData.forEach(slot => {
        if (slot.sport && slot.sport.name) {
          sports.add(slot.sport.name);
        }
      });
      setAvailableSports(Array.from(sports));
    }
  }, [slotViewData]);

  // Show error if slot creation fails
  useEffect(() => {
    if (slotError) {
      toast.error(slotError);
    }
  }, [slotError]);

  const handleSportFilterChange = (sportName, checked) => {
    if (checked) {
      setSelectedSports([...selectedSports, sportName]);
    } else {
      setSelectedSports(selectedSports.filter(sport => sport !== sportName));
    }
  };

  const handleFacilityFilterChange = (facilityName, checked) => {
    if (checked) {
      setSelectedFacilities([...selectedFacilities, facilityName]);
    } else {
      setSelectedFacilities(selectedFacilities.filter(name => name !== facilityName));
    }
  };

  const applyFilters = (type) => {
    if (type === 'sports') {
      setSportsFilterOpen(false);
    } else if (type === 'facilities') {
      setFacilitiesFilterOpen(false);
    }
    setCurrentPage(1); // Reset to first page when applying filters
  };

  // Update the getFilteredSlots function
  const getFilteredSlots = () => {
    let filteredSlots = [...slotViewData];

    // Apply sports filter
    if (selectedSports.length > 0) {
      filteredSlots = filteredSlots.filter(slot => selectedSports.includes(slot.sport.name));
    }

    // Apply facility filter using facility name
    if (selectedFacilities.length > 0) {
      filteredSlots = filteredSlots.filter(slot => {
        const facilityName = slot.facility?.name || '';
        return selectedFacilities.includes(facilityName);
      });
    }

    // Sort in descending order based on the 'from' date
    return filteredSlots.sort((a, b) => {
      const dateA = new Date(moment(a.date.from, 'MM-DD-YYYY'));
      const dateB = new Date(moment(b.date.from, 'MM-DD-YYYY'));
      return dateB - dateA;
    });
  };

  const getCurrentSlots = () => {
    const filteredSlots = getFilteredSlots();
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return filteredSlots.slice(indexOfFirstItem, indexOfLastItem);
  };

  const totalPages = Math.ceil(getFilteredSlots().length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleReviewClick = (slot) => {
    setSelectedSlot(slot);
    setShowReviewOffcanvas(true);
  };

  const handleReplicateClick = (slot) => {
    setSelectedSlot(slot);
    setReplicateData({
      name: "",
      startDate: new Date(),
      endDate: new Date(),
    });
    setShowReplicateModal(true);
  };

  const handleReplicateNext = () => {
    if (!replicateData.name || !replicateData.startDate || !replicateData.endDate) {
      toast.error("Please provide all fields");
      return;
    }

    // Check if start date is after today
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (replicateData.startDate < today) {
      toast.error("Start date should be greater than today's date");
      return;
    }

    // Check if end date is after start date
    if (replicateData.endDate < replicateData.startDate) {
      toast.error("End date should be after start date");
      return;
    }

    setShowReplicateModal(false);
    setShowReplicateReviewModal(true);
  };

  const handleReplicateConfirm = async () => {
    if (!selectedSlot) {
      toast.error("No slot selected for replication");
      return;
    }

    try {
      // Check if selected date range includes all of the configured days
      const startDate = moment(replicateData.startDate);
      const endDate = moment(replicateData.endDate);
      const daysBetween = endDate.diff(startDate, 'days');

      // If start and end dates are the same, we need to check at least one day
      const totalDaysToCheck = startDate.isSame(endDate, 'day') ? 0 : daysBetween;

      console.log('Parsed start date:', startDate.format('YYYY-MM-DD'));
      console.log('Parsed end date:', endDate.format('YYYY-MM-DD'));
      console.log('Start date day of week:', startDate.day(), getDayName(startDate.day()));
      console.log('End date day of week:', endDate.day(), getDayName(endDate.day()));

      // Get the configured day numbers from the selected slot
      if (!selectedSlot?.days || !Array.isArray(selectedSlot.days)) {
        toast.error("Invalid slot data: days configuration is missing");
        return;
      }

      const configuredDays = selectedSlot.days.map(day => getDayNumber(day));

      // Debug logging
      console.log('Selected slot days:', selectedSlot.days);
      console.log('Configured days (numbers):', configuredDays);
      console.log('Start date:', replicateData.startDate);
      console.log('End date:', replicateData.endDate);
      console.log('Days between:', daysBetween);

      // Track which configured days are found in the range
      const foundDays = new Set();

      // Check each day in the date range (including end date)
      for (let i = 0; i <= totalDaysToCheck; i++) {
        const currentDate = moment(startDate).add(i, 'days');
        const dayOfWeek = currentDate.day(); // 0 is Sunday, 1 is Monday, etc.

        console.log(`Day ${i}: ${currentDate.format('YYYY-MM-DD')} (${getDayName(dayOfWeek)}) - Day number: ${dayOfWeek}`);

        // If this day is in the configured days, mark it as found
        if (configuredDays.includes(dayOfWeek)) {
          foundDays.add(dayOfWeek);
          console.log(`Found configured day: ${getDayName(dayOfWeek)}`);
        }
      }

      // Check if at least one configured day was found
      const foundDaysArray = Array.from(foundDays);

      console.log('Found days array:', foundDaysArray);
      console.log('Found days names:', foundDaysArray.map(day => getDayName(day)));

      if (foundDaysArray.length === 0) {
        const configuredDayNames = configuredDays.map(day => getDayName(day)).join(", ");
        toast.error(
          `Selected date range does not include any of the configured days. ` +
          `Please select a date range that includes: ${configuredDayNames}`
        );
        return;
      }

      // If some configured days are missing, show a warning but allow replication
      const missingDays = configuredDays.filter(day => !foundDays.has(day));
      if (missingDays.length > 0) {
        const missingDayNames = missingDays.map(day => getDayName(day)).join(", ");
        const foundDayNames = foundDaysArray.map(day => getDayName(day)).join(", ");
        toast.warning(
          `Replicating for selected days: ${foundDayNames}. ` +
          `Missing days: ${missingDayNames}. You can proceed with partial replication.`
        );
      }

      setLoading(true);

      if (!selectedSlot?.days || !Array.isArray(selectedSlot.days) || selectedSlot.days.length === 0) {
        toast.error("Invalid slot data: days configuration is missing");
        return;
      }

      const firstDay = selectedSlot.days[0];
      if (!firstDay?.slot || !Array.isArray(firstDay.slot) || firstDay.slot.length === 0) {
        toast.error("Invalid slot data: time slots are missing");
        return;
      }

      // Create unique time templates (no old dates, no duplicates)
      const uniqueTimeMap = new Map();
      firstDay.slot.forEach(timeSlot => {
        const from = moment(timeSlot.from, ['HH:mm', 'hh:mm A']).format('HH:mm');
        const to = moment(timeSlot.to, ['HH:mm', 'hh:mm A']).format('HH:mm');
        const key = `${from}-${to}`;

        if (!uniqueTimeMap.has(key)) {
          uniqueTimeMap.set(key, {
            from,
            to,
            price: timeSlot.price
          });
        }
      });

      const uniqueSlots = Array.from(uniqueTimeMap.values());

      // Build selectedDates cleanly
      const dayDates = getDayDatesInRange(
        replicateData.startDate,
        replicateData.endDate,
        configuredDays
      );

      const selectedDatesList = dayDates.map(dayDate => ({
        date: dayDate.fullDate,
        dayName: dayDate.dayName,
        slots: uniqueSlots.map(s => ({ ...s }))
      }));

      // Prepare the payload
      const payload = {
        name: replicateData.name,
        sport: selectedSlot.sport._id,
        facility: selectedSlot.facility,
        pitch: selectedSlot.pitch._id,
        date: {
          from: moment(replicateData.startDate).format('MM-DD-YYYY'),
          to: moment(replicateData.endDate).format('MM-DD-YYYY')
        },
        selectedDates: selectedDatesList
      };

      // Dispatch
      await dispatch(createSlot(payload)).unwrap();

      // Close the review modal
      setShowReplicateReviewModal(false);

      // Show success toast notification
      toast.success("Slot replicated successfully!");

      // Refresh the slots list
      dispatch(fetchAllSlots());
    } catch (error) {
      console.error("Error replicating slot:", error);
      toast.error(error.message || "An error occurred while replicating the slot");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (slot) => {
    setSlotToDelete(slot);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!slotToDelete?._id) {
      toast.error("Invalid slot ID");
      return;
    }

    try {
      setLoading(true);
      console.log("Attempting to delete slot with ID:", slotToDelete._id);

      const response = await deleteParentSlot(slotToDelete._id);
      console.log("Delete response:", response.data);

      if (response.data.status) {
        toast.success(response.data.message || "Slot deleted successfully")
        setShowDeleteModal(false);
        setSlotToDelete(null);

        // Refresh the slots list
        dispatch(fetchAllSlots());
      } else {
        toast.error(response.data.message || "Failed to delete slot");
      }
    } catch (error) {
      console.error("Error deleting slot:", error);
      toast.error(error.response?.data?.message || "Failed to delete slot");
    } finally {
      setLoading(false);
    }
  };

  // Add this helper function at the top level
  const formatSlotTime = (time) => {
    return moment(time, 'HH:mm').format('hh:mm A');
  };

  // Helper to safely get day name
  const getDayName = (dayNumber) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[dayNumber] || `Day ${dayNumber}`;
  };

  // Helper to get day number from day object or number
  const getDayNumber = (dayData) => {
    if (typeof dayData === 'number') {
      return dayData;
    }
    if (dayData && typeof dayData === 'object' && dayData.day !== undefined) {
      return dayData.day;
    }
    return 0; // Default to Sunday
  };

  // Helper to get specific dates for each day within a date range
  const getDayDatesInRange = (startDate, endDate, dayNumbers) => {
    const dates = [];
    const start = moment(startDate).startOf('day');
    const end = moment(endDate).endOf('day');
    const daysDiff = end.diff(start, 'days');

    for (let i = 0; i <= daysDiff; i++) {
      const currentDate = moment(start).add(i, 'days');
      const dayOfWeek = currentDate.day(); // 0 is Sunday, 1 is Monday, etc.

      if (dayNumbers.includes(dayOfWeek)) {
        dates.push({
          dayNumber: dayOfWeek,
          dayName: getDayName(dayOfWeek),
          date: currentDate.format('MMM D, YYYY'),
          fullDate: currentDate.format('YYYY-MM-DD')
        });
      }
    }

    return dates;
  };

  // Render skeleton cards
  const renderSkeletons = () => {
    return (
      <div className="row col-sm-12 g-4">
        {Array.from({ length: 6 }).map((_, index) => (
          <SkeletonSlotCard key={`skeleton-${index}`} />
        ))}
      </div>
    );
  };

  // Update the renderEmpty function to match the pitches UI
  const renderEmpty = () => {
    return (
      <Col md={12} className="d-flex justify-content-center" style={{ marginTop: "5%", marginBottom: "15%" }}>
        <Card className="text-center p-5">
          <Card.Body>
            <div style={{
              width: "50px",
              height: "50px",
              margin: "0 auto 20px auto",
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px"
            }}>
              📅
            </div>
            <Card.Title>No Slots Available</Card.Title>
            <Card.Text className="text-muted">
              {getFilteredSlots().length === 0 && (selectedSports.length > 0 || selectedFacilities.length > 0)
                ? "There are no slots matching your current filters. Try changing your filter criteria."
                : "No slots have been created yet. Create your first slot to get started."}
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    );
  };

  return (
    <Container>
      <h1 className="container-title">Slots Management</h1>

      <div className="filtersslots">

        {/* Facilities Filter */}
        <Dropdown
          className="slots-dropdown"
          show={facilitiesFilterOpen}
          onToggle={(isOpen) => setFacilitiesFilterOpen(isOpen)}
          disabled={isLoading}
        >
          <Dropdown.Toggle
            variant="light"
            id="dropdown-facilities"
            className="filter-dropdown"
          >
            {selectedFacilities.length > 0
              ? `${selectedFacilities.length} Facilities Selected`
              : "Select Facilities"}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Form.Group className="p-3">
              {facilities.map((facility, idx) => {
                const id = `facility-${idx}-${facility.name.replace(/\s+/g, "-").toLowerCase()}`;
                return (
                  <React.Fragment key={id}>
                    <Form.Check
                      type="checkbox"
                      id={id}                        // <--- unique id for each checkbox
                      name="facilities"
                      value={facility.name}
                      label={facility.name}
                      checked={selectedFacilities.includes(facility.name)}
                      onChange={(e) => handleFacilityFilterChange(facility.name, e.target.checked)}
                    />
                    {idx < facilities.length - 1 && <hr className="my-2" />}
                  </React.Fragment>
                );
              })}
            </Form.Group>

            <div className="p-3">
              <Button
                variant="success"
                className="w-100"
                onClick={() => applyFilters('facilities')}
              >
                Apply Filters
              </Button>
            </div>
          </Dropdown.Menu>
        </Dropdown>


        {/* Sports Filter */}
        <Dropdown
          className="slots-dropdown me-3"
          show={sportsFilterOpen}
          onToggle={(isOpen) => setSportsFilterOpen(isOpen)}
          disabled={isLoading}
        >
          <Dropdown.Toggle
            variant="light"
            id="dropdown-sports"
            className="filter-dropdown"
          >
            {selectedSports.length > 0
              ? `${selectedSports.length} Sports Selected`
              : "Select Sports"}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Form.Group className="p-3"> {/* removed controlId */}
              {availableSports.map((sport, index) => {
                const id = `sport-${index}-${sport.replace(/\s+/g, "-").toLowerCase()}`;

                return (
                  <React.Fragment key={id}>
                    <Form.Check
                      type="checkbox"
                      id={id}                    // ← unique id for correct label → checkbox binding
                      label={sport}
                      checked={selectedSports.includes(sport)}
                      onChange={(e) => handleSportFilterChange(sport, e.target.checked)}
                    />
                    {index < availableSports.length - 1 && <hr className="my-2" />}
                  </React.Fragment>
                );
              })}
            </Form.Group>

            <div className="p-3">
              <Button
                variant="success"
                className="w-100"
                onClick={() => applyFilters('sports')}
              >
                Apply Filters
              </Button>
            </div>
          </Dropdown.Menu>
        </Dropdown>



      </div>

      <div className="slots-grid">
        {isLoading ? (
          renderSkeletons()
        ) : getFilteredSlots().length === 0 ? (
          renderEmpty()
        ) : (
          <div className="row col-sm-12 g-4">
            {getCurrentSlots().map((slot) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={slot._id}>
                <div className="slot-card-wrapper animate-in">
                  <div className="d-flex justify-content-between mb-2">
                    <div className="pitch-info">
                      <h3 className="pitch-title">{slot.facility?.name}</h3>
                      <div className="slot-date">
                        <img
                          src={CalenderIcon}
                          alt="calendar"
                          style={{ tintColor: '#333333' }}
                        />
                        <p style={{ marginTop: '3px' }} className="pitch-info-text">{slot.date.from} - {slot.date.to}</p>
                      </div>
                      {/* <p className="pitch-info-text">Facility: {pitch.facilityName || "N/A"}</p> */}
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <div className="sport-icon-container">
                        <LazyImage
                          src={sportIcons[slot.sport?.name] || sportIcons["cross"]}
                          alt={slot.sport?.name}
                        />
                      </div>
                      <div className="sport-icon-text">{slot.sport?.name || "N/A"}</div>
                    </div>
                  </div>



                  <div className="slot-title-wrapper">
                    <h3 className="slot-title">{slot.name}</h3>
                    <button
                      className="delete-slot-btn"
                      onClick={() => handleDeleteClick(slot)}
                      title="Delete slot"
                    >
                      <img style={{ tintColor: '#333333' }} src={TrashIcon} alt="delete" />
                    </button>
                  </div>


                  <div className="slot-days-tags">
                    {slot.days?.length ? (
                      slot.days.map((dayData) => {
                        const dayName = getDayName(getDayNumber(dayData));
                        const slotCount = dayData.slot?.length ?? 0;
                        const shortDayName = dayName.substring(0, 3).toUpperCase();
                        return (
                          <div key={dayData._id} className="day-tag">
                            <span className="day-name">{shortDayName}</span>
                            <span className="slot-count">{`${slotCount}slots`}</span>
                          </div>
                        );
                      })
                    ) : (
                      <span className="text-muted">No days configured</span>
                    )}
                  </div>


                  <div className="slot-actions">
                    <button
                      className="btn-replicate"
                      onClick={() => handleReplicateClick(slot)}
                    >
                      Replicate Slot
                    </button>
                    <button
                      className="btn-review"
                      onClick={() => handleReviewClick(slot)}
                    >
                      Review Slot
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Show pagination only when we have data and not loading */}
      {!isLoading && totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <nav>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages)].map((_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {/* Replace Review Modal with Offcanvas */}
      <Offcanvas
        show={showReviewOffcanvas}
        onHide={() => setShowReviewOffcanvas(false)}
        placement="end"
        className="custom-offcanvas"
      >
        {/* <Offcanvas.Header closeButton> */}
        <Offcanvas.Title className="canvas-title">
          Review Slot
        </Offcanvas.Title>
        {/* </Offcanvas.Header> */}
        <Offcanvas.Body style={{ paddingTop: '0px' }}>
          {selectedSlot && (
            <div className="booking-details">
              {/* 1. Slot Information Section - On Top */}
              <h3 className="booking-title-head">Slot Information</h3>
              <div className="booking-imp-details">
                <Row>
                  <Col lg={6}>
                    <div className="schd-details">
                      <img src={idcard} alt="Slot Name" />
                      <span className="booking-date-schd">Slot Name</span>
                    </div>
                    <p className="data-schd">{selectedSlot.name}</p>
                  </Col>
                  <Col lg={6}>
                    <div className="schd-details">
                      <img src={sportsicon} alt="Sport" />
                      <span className="booking-date-schd">Sport</span>
                    </div>
                    <p className="data-schd">{selectedSlot.sport?.name || "N/A"}</p>
                  </Col>
                  <hr />
                </Row>

                <Row>
                  <Col lg={6}>
                    <div className="schd-details">
                      <img src={dateicon} alt="Start Date" />
                      <span className="booking-date-schd">Start Date</span>
                    </div>
                    <p className="data-schd">{selectedSlot.date.from}</p>
                  </Col>
                  <Col lg={6}>
                    <div className="schd-details">
                      <img src={dateicon} alt="End Date" />
                      <span className="booking-date-schd">End Date</span>
                    </div>
                    <p className="data-schd">{selectedSlot.date.to}</p>
                  </Col>
                  <hr />
                </Row>

                <Row>
                  <Col lg={6}>
                    <div className="schd-details">
                      <img src={facilityicon} alt="Facility" />
                      <span className="booking-date-schd">Facility</span>
                    </div>
                    <p className="data-schd">{selectedSlot.facility?.name || "N/A"}</p>
                  </Col>
                  <Col lg={6}>
                    <div className="schd-details">
                      <img src={pitch} alt="Pitch" />
                      <span className="booking-date-schd">Pitch/Court</span>
                    </div>
                    <p className="data-schd">{selectedSlot.pitch?.name || "N/A"}</p>
                  </Col>
                  <hr />
                </Row>
              </div>

              {/* 2. Slot Details Section - At Bottom */}
              <h3 className="booking-title-head">Slot Details</h3>
              <div className="schedule-information">
                {selectedSlot.days?.map((dayData) => (
                  <div key={dayData._id} className="day-slots-section" style={{ background: 'transparent', padding: '0', margin: '0' }}>
                    <div className="day-header d-flex justify-content-between align-items-center" style={{ marginBottom: '12px', paddingBottom: '8px', borderBottom: '1px solid #e9ecef' }}>
                      <div className="d-flex align-items-center">
                        <img src={smallcal} alt="Day" style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                        <div>
                          <span className="day-name" style={{ fontSize: '14px', fontWeight: '600', color: '#2c3e50', display: 'block' }}>{getDayName(getDayNumber(dayData))}</span>
                          {dayData.slot && dayData.slot.length > 0 && dayData.slot[0].date && (
                            <span className="day-date" style={{ fontSize: '11px', color: '#6c757d', display: 'block', marginTop: '2px' }}>
                              {moment(dayData.slot[0].date).format('MMM D, YYYY')}
                            </span>
                          )}
                        </div>
                      </div>
                      <span className="slot-count-badge" style={{ fontSize: '11px', padding: '2px 8px', background: '#e8f5e9', color: '#28a745', borderRadius: '12px' }}>
                        {dayData.slot?.length || 0} slots
                      </span>
                    </div>
                    <div className="slots-list" style={{ margin: '0', padding: '0' }}>
                      {dayData.slot?.map((timeSlot) => (
                        <div key={timeSlot._id} className="time-slot-card" style={{ display: 'flex', paddingRight: '8px', paddingLeft: '8px', justifyContent: 'space-between', alignItems: 'center', }}>
                          <Form style={{ margin: 0 }}>
                            <Form.Check
                              type="radio"
                              id={`slot-${timeSlot._id}`}
                              label={`${formatSlotTime(timeSlot.from)} - ${formatSlotTime(timeSlot.to)}`}
                              name="radioGroup"
                              className="green-radio"
                              checked={true}
                              readOnly
                            />
                          </Form>
                          <div className="time-slot-price" style={{ fontSize: '14px', color: '#28a745', fontWeight: '500', marginLeft: '16px' }}>
                            {timeSlot.price} PKR
                          </div>
                        </div>
                      )) || (
                          <div className="text-muted" style={{ fontSize: '12px', color: '#6c757d' }}>No time slots configured</div>
                        )}
                    </div>
                  </div>
                )) || (
                    <div className="text-muted" style={{ fontSize: '12px', color: '#6c757d' }}>No days configured</div>
                  )}
              </div>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* Replicate Slot Modal */}
      <Modal show={showReplicateModal} onHide={() => setShowReplicateModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Replicate Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedSlot && (
            <>
              <div className="mb-4">
                <p className="text-muted">Source slot "{selectedSlot.name}"</p>
              </div>

              <div className="mb-4">
                <h6>Select Dates</h6>
                <div className="alert alert-info">
                  <small>
                    <i className="bi bi-info-circle me-2"></i>
                    This slot can only be replicated for: {selectedSlot.days?.map(day => getDayName(getDayNumber(day)))?.join(", ") || "No days configured"}
                  </small>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">From</label>
                    <DatePicker
                      selected={replicateData.startDate}
                      onChange={(date) => setReplicateData({ ...replicateData, startDate: date })}
                      className="form-control"
                      dateFormat="MM-dd-yyyy"
                      minDate={new Date()}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">To</label>
                    <DatePicker
                      selected={replicateData.endDate}
                      onChange={(date) => setReplicateData({ ...replicateData, endDate: date })}
                      className="form-control"
                      dateFormat="MM-dd-yyyy"
                      minDate={replicateData.startDate}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h6>Slot Name</h6>
                <input
                  type="text"
                  className="form-control"
                  value={replicateData.name}
                  onChange={(e) => setReplicateData({ ...replicateData, name: e.target.value })}
                  placeholder="Enter slot name"
                />
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleReplicateNext}>
            Next
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Replicate Review Modal */}
      <Modal show={showReplicateReviewModal} onHide={() => setShowReplicateReviewModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Review Replicated Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedSlot && (
            <>
              <div className="d-flex align-items-center mb-4">
                <div className="sport-logo-circle me-3">
                  <LazyImage
                    src={sportIcons[selectedSlot.sport?.name] || sportIcons["cross"] || sportImage}
                    alt="Sport"
                    className="sport-logo"
                    style={{ backgroundColor: "white", border: "3px solid #38b001" }}
                  />
                </div>
                <h5 className="mb-0">{replicateData.name}</h5>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <p><strong>Start Date:</strong> {moment(replicateData.startDate).format('MM-DD-YYYY')}</p>
                </div>
                <div className="col-md-6">
                  <p><strong>End Date:</strong> {moment(replicateData.endDate).format('MM-DD-YYYY')}</p>
                </div>
              </div>

              <div className="mb-4">
                <h6>Facility</h6>
                <div className="selected-pitch">
                  {selectedSlot.facility?.name || 'N/A'}
                </div>
              </div>

              <div className="mb-4">
                <h6>Pitch/Court</h6>
                <div className="selected-pitch">
                  {selectedSlot.pitch?.name || 'N/A'}
                </div>
              </div>

              <div className="mb-4">
                <h6>Available Days</h6>
                <div className="d-flex flex-wrap">
                  {selectedSlot.days?.map((day, index) => {
                    const dayNumber = getDayNumber(day);
                    const dayName = getDayName(dayNumber);
                    return (
                      <div key={index} className="selected-day">
                        {dayName}
                      </div>
                    );
                  }) || (
                      <div className="text-muted">No days configured</div>
                    )}
                </div>
              </div>

              <div className="mb-4">
                <h6>Specific Dates for Selected Range</h6>
                <div className="alert alert-info">
                  <small>
                    <i className="bi bi-info-circle me-2"></i>
                    The following dates will be created for the selected range:
                  </small>
                </div>
                {(() => {
                  if (!selectedSlot?.days || !Array.isArray(selectedSlot.days)) {
                    return (
                      <div className="alert alert-warning">
                        <small>
                          <i className="bi bi-exclamation-triangle me-2"></i>
                          No day configuration found for this slot.
                        </small>
                      </div>
                    );
                  }

                  const configuredDays = selectedSlot.days.map(day => getDayNumber(day));
                  const dayDates = getDayDatesInRange(replicateData.startDate, replicateData.endDate, configuredDays);

                  if (dayDates.length === 0) {
                    return (
                      <div className="alert alert-warning">
                        <small>
                          <i className="bi bi-exclamation-triangle me-2"></i>
                          No matching days found in the selected date range. Please adjust your dates.
                        </small>
                      </div>
                    );
                  }

                  return (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                        gap: '14px',
                        marginBottom: '16px'
                      }}
                    >
                      {dayDates.map((dayDate, index) => (
                        <div key={index} className="day-date-item">
                          <span className="day-name">{dayDate.dayName}</span>
                          <span className="date-value">{dayDate.date}</span>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>

              {/* Update the replicate review modal slots section */}
              <div>
                <h6>Available Slots</h6>
                {(() => {
                  if (!selectedSlot?.days || !Array.isArray(selectedSlot.days)) {
                    return (
                      <div className="alert alert-warning">
                        <small>
                          <i className="bi bi-exclamation-triangle me-2"></i>
                          No day configuration found for this slot.
                        </small>
                      </div>
                    );
                  }

                  const configuredDays = selectedSlot.days.map(day => getDayNumber(day));
                  const dayDates = getDayDatesInRange(replicateData.startDate, replicateData.endDate, configuredDays);

                  if (dayDates.length === 0) {
                    return (
                      <div className="alert alert-warning">
                        <small>
                          <i className="bi bi-exclamation-triangle me-2"></i>
                          No matching days found in the selected date range.
                        </small>
                      </div>
                    );
                  }

                  return dayDates.map((dayDate, index) => (
                    <div key={index} className="day-slots-section mb-4">
                      <h6 className="day-header">
                        <i className="bi bi-calendar me-2"></i>
                        {dayDate.dayName} - {dayDate.date}
                      </h6>
                      <div className="slots-list">
                        {selectedSlot.days.find(day => getDayNumber(day) === dayDate.dayNumber)?.slot?.map((timeSlot, slotIndex) => (
                          <div key={slotIndex}
                            style={{
                              borderBottom: '1px solid #e0e0e0',
                              borderRadius: '8px',
                              padding: '10px 10px',
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: "flex-start",
                              backgroundColor: '#fff',
                              transition: 'box-shadow 0.2s ease'
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <i className="bi bi-clock me-2"></i>
                              <div>
                                <div className="slot-time">
                                  {formatSlotTime(timeSlot.from)} - {formatSlotTime(timeSlot.to)}
                                </div>
                                <div style={{ marginBottom: 0 }} className="slot-date text-muted small">
                                  {dayDate.date}
                                </div>
                              </div>
                            </div>
                            <div
                              className="slot-date text-muted small"
                            >
                              {timeSlot.price} PKR
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ));
                })()}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReplicateReviewModal(false)}>
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleReplicateConfirm}
            disabled={loading}
          >
            {loading ? 'Replicating...' : 'Confirm Replication'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this slot?</p>
          {slotToDelete && (
            <div className="slot-details">
              <p><strong>Name:</strong> {slotToDelete.name}</p>
              <p><strong>Date:</strong> {slotToDelete.date.from} - {slotToDelete.date.to}</p>
              <p><strong>Facility: </strong><span className="facility-owner badge bg-success">{slotToDelete.facility?.name || 'N/A'}</span></p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="btn w-100"
            className="btn-modal-delete-slot"
            onClick={handleDeleteConfirm}
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        .slot-card {
          position: relative;
        }
        
        .delete-slot-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          background: transparent;
          border: none;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 1;
          transition: all 0.2s;
          padding: 0;
        }
        
        .delete-slot-btn:hover {
          transform: scale(1.1);
        }

        .delete-slot-btn img {
          width: 20px;
          height: 20px;
        }

        .slot-details {
          background-color: #f8f9fa;
          padding: 15px;
          border-radius: 5px;
          margin-top: 10px;
        }

        .slot-details p {
          margin-bottom: 5px;
        }

        .slot-card-wrapper {
          background: #fff;
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          height: 100%;
        }

        .slot-title-skeleton {
          margin: 15px 0;
        }

        .fullscreen-loader {
          display: none;
        }

        .day-slots-section {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 16px;
        }

        .day-header {
          padding-bottom: 12px;
          margin-bottom: 12px;
          border-bottom: 1px solid #e9ecef;
        }

        .day-name {
          font-size: 16px;
          font-weight: 600;
          color: #2e7d32;
        }

        .slot-count-badge {
          background: linear-gradient(45deg, #28a745, #2ecc71);
          color: white;
          padding: 5px 12px;
          border-radius: 16px;
          font-size: 12px;
          font-weight: 500;
          box-shadow: 0 2px 4px rgba(46, 204, 113, 0.2);
        }

        .slots-list {
          display: grid;
          gap: 8px;
        }

        .time-slot-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: white;
          padding: 10px 16px;
          border-radius: 6px;
          border: 1px solid #e9ecef;
        }

        .time-info {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .time-range {
          font-size: 14px;
          font-weight: 500;
          color: #212529;
          display: flex;
          align-items: center;
        }

        .time-range i {
          font-size: 14px;
          color: #6c757d;
        }

        .date-label {
          font-size: 12px;
          color: #6c757d;
          margin-left: 22px;
        }

        .price-tag {
          font-weight: 500;
          color: #28a745;
          background: #e8f5e9;
          padding: 6px 12px;
          border-radius: 16px;
          font-size: 13px;
          white-space: nowrap;
        }

        .selected-pitch {
          background: #f8f9fa;
          padding: 12px 16px;
          border-radius: 6px;
          color: #495057;
          font-weight: 500;
        }

        .sport-logo-circle {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #e8f5e9;
        }

        .sport-logo-circle img {
          width: 28px;
          height: 28px;
        }

        .slot-title-wrapper {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 12px;
        }

        .slot-title {
          margin: 0;
          flex: 1;
          font-size: 18px;
          color: #212529;
        }

        .delete-slot-btn {
          position: static;
          background: transparent;
          border: none;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
          padding: 0;
          opacity: 0.6;
        }

        .delete-slot-btn:hover {
          transform: scale(1.1);
          opacity: 1;
        }

        .delete-slot-btn img {
          width: 16px;
          height: 16px;
        }

        /* Day tag styles - no background, no padding */
        .day-tag {
          display: flex;
          align-items: center;
          gap: 8px;
          background: none;
          color: #666666;
          padding: 0;
          font-size: 13px;
          font-weight: 500;
        }

        .slot-count {
          background: none;
          color: #666666;
          padding: 0;
          font-size: 11px;
          font-weight: 400;
        }

        .slot-days {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin: 15px 0;
        }

        /* Update the slot count badge in the day header as well */
        .slot-count-badge {
          background: linear-gradient(45deg, #28a745, #2ecc71);
          color: white;
          padding: 5px 12px;
          border-radius: 16px;
          font-size: 12px;
          font-weight: 500;
          box-shadow: 0 2px 4px rgba(46, 204, 113, 0.2);
        }

        .day-header {
          padding-bottom: 12px;
          margin-bottom: 12px;
          border-bottom: 1px solid #e9ecef;
        }

        .day-name {
          font-size: 16px;
          font-weight: 600;
          color: #2e7d32;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .day-name i {
          color: #28a745;
          font-size: 14px;
        }

        .slots-grid {
          min-height: 400px; /* Maintain consistent height during transitions */
          position: relative;
        }

        .animate-in {
          animation: fadeSlideIn 0.3s ease-out;
          opacity: 1;
          transform: translateY(0);
        }

        @keyframes fadeSlideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .slot-card-wrapper {
          transition: all 0.3s ease;
        }

        .slot-card-wrapper:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        /* Add transition for filter changes */
        .row {
          transition: opacity 0.3s ease;
        }

        /* Smooth transition for filter badges */
        .filter-dropdown {
          transition: all 0.2s ease;
        }

        .filter-dropdown:hover {
          background-color: #f8f9fa;
        }

        /* Add animation for filter selections */
        .form-check {
          transition: all 0.2s ease;
        }
        .form-check-input:checked + .form-check-label {
          color: #28a745;
          font-weight: 500;
        }

        /* Add styles for the offcanvas */
        :global(.review-offcanvas) {
          width: 500px !important;
        }

        :global(.review-offcanvas .offcanvas-header) {
          background: #f8f9fa;
          border-bottom: 1px solid #dee2e6;
          padding: 1rem 1.5rem;
        }

        :global(.review-offcanvas .offcanvas-title) {
          font-size: 1.25rem;
          font-weight: 600;
          color: #212529;
        }

        :global(.review-offcanvas .offcanvas-body) {
          padding: 1.5rem;
        }

        .review-offcanvas-content {
          height: 100%;
          overflow-y: auto;
        }

        .review-offcanvas-content::-webkit-scrollbar {
          width: 6px;
        }

        .review-offcanvas-content::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 3px;
        }

        .review-offcanvas-content::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 3px;
        }

        .review-offcanvas-content::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }

        /* Enhance the time slot items for offcanvas */
        .time-slot-item {
          transition: all 0.2s ease;
        }

        .time-slot-item:hover {
          transform: translateX(4px);
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        }

        /* Add slide animation for offcanvas */
        :global(.review-offcanvas.offcanvas.offcanvas-end) {
          transition: transform 0.3s ease-in-out;
        }

        :global(.review-offcanvas.offcanvas.offcanvas-end.show) {
          animation: slideIn 0.3s ease-out;
        }

        @keyframes slideIn {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }

        /* Styles for day-date display */
        .day-dates-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 12px;
        }

        .day-date-item {
          // display: flex;
          // justify-content: space-between;
          // align-items: center;
          // background: #f8f9fa;
          padding: 10px 10px;
          border-radius: 8px;
          border: 1px solid #e9ecef;
        }

        .day-date-item .day-name {
          font-weight: 600;
          color: #28a745;
          font-size: 14px;
        }

        .day-date-item .date-value {
          color: #6c757d;
          font-size: 13px;
          font-weight: 500;
        }
      `}</style>
    </Container>
  );
};

export default Slots;